module.exports = __webpack_public_path__ + "static/media/game-end-red-chip.2dca5a46.svg";